import { Alert, Overlay } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect } from 'react';
import { useBagScanContext } from './hook';
import styles from './styles.module.css';

export const BagScanErrorHandler = () => {
	const { error, setError } = useBagScanContext();

	useEffect(() => {
		if (error) {
			setTimeout(() => {
				setError(null);
			}, 4000);
		}
	}, [error, setError]);

	return (
		<AnimatePresence>
			{error === 'ALREADY_SCANNED' && (
				<motion.div
					key="already-scanned"
					className={styles.errorAlert}
					initial={{ opacity: 0, y: 10 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: 10 }}
					transition={{ duration: 0.5 }}
				>
					<Alert variant="filled" color="red" title="Already Scanned" icon={<IconAlertCircle />}>
						Oops! This bag has already been scanned. Please scan a different bag.
					</Alert>
				</motion.div>
			)}
			{error === 'INVALID_CODE' && (
				<motion.div
					key="invalid-code"
					className={styles.errorAlert}
					initial={{ opacity: 0, y: 10 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: 10 }}
					transition={{ duration: 0.5 }}
				>
					<Alert variant="filled" color="red" title="Invalid Code" icon={<IconAlertCircle />}>
						It looks like the code you've scanned or manually entered is invalid. Please check the
						details and try again.
					</Alert>
				</motion.div>
			)}
			{error === 'NOT_AUTHORISED' && (
				<motion.div
					key="not-authorised"
					className={styles.errorAlert}
					initial={{ opacity: 0, y: 10 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: 10 }}
					transition={{ duration: 0.5 }}
				>
					<Alert variant="filled" color="red" title="Unauthorised" icon={<IconAlertCircle />}>
						It looks like your account is not authorised to scan bags. Please contact support if you
						believe this is an error.
					</Alert>
				</motion.div>
			)}
			{error === 'UNKNOWN_ERROR' && (
				<motion.div
					key="unknown-error"
					className={styles.errorAlert}
					initial={{ opacity: 0, y: 10 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: 10 }}
					transition={{ duration: 0.5 }}
				>
					<Alert variant="filled" color="red" title="Error" icon={<IconAlertCircle />}>
						An error occurred while scanning the bag. Please try again.
					</Alert>
				</motion.div>
			)}
			{error && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.5 }}
					key="overlay"
				>
					<Overlay color="#000" backgroundOpacity={0.85} />
				</motion.div>
			)}
		</AnimatePresence>
	);
};
